import { VIDEO_TYPE, LIB_PLAYER, Time_Sleep_Restart_Standard, Time_Analytics_Sender_Interval, WEB_SOCKET_URL, MIN_VALUE_TO_SEND, NEED_ANALYTICS, CAN_CALL_ADS_PLAYING_DB, ADS_ROLL_TYPE, ADS_WATCHED, ADS_NOT_WATCHED, ADS_TIME, ADS_ROLL_TYPE_BRID, } from "@constants";
import { AdsAutopromotions } from "./AdsAutopromotions";
import { AdsBridJs } from "./AdsBridJs";
import { AdsVideoJs } from "./AdsVideoJs";
// sta in un modulo a parte perche' questo file e' @ts-nocheck e non si puo' importare nei test
import { normalizeMidRollTimes } from "./midRollSchedule";
import { apiAds } from "../../services/ads";
/**
 * Converte la struttura tagVast usata dal codice React nella struttura
 * pre_roll/mid_roll/post_roll attesa dal codice advertising vecchio.
 * TODO aggiornare in futuro
 * Gli array mancanti vengono inizializzati vuoti per mantenere identico il
 * funzionamento degli iteratori anche per le Live, che non hanno post-roll.
 */
function normalizeTagVast(tagVast) {
    const normalizeRoll = (roll) => (roll ?? []).map((tagVastData) => ({
        ...tagVastData,
        tag_vast: tagVastData.tag_vast ?? "",
    }));
    return {
        pre_roll: normalizeRoll(tagVast?.pre_roll),
        mid_roll: normalizeRoll(tagVast?.mid_roll),
        post_roll: normalizeRoll("post_roll" in (tagVast ?? {}) ? tagVast?.post_roll : null),
    };
}
/**
 * Recupera l'elemento video reale associato al player.
 * Per Brid VideoPlayer passa esplicitamente il vecchio elemento <video>,
 * perché il builder Brid lo sostituisce nel DOM con il proprio container.
 * //TODO LIB vedere se funziona
 */
function getVideoContent(player, params) {
    if (params.videoContent) {
        return params.videoContent;
    }
    if (typeof player?.el === "function") {
        return (player.el()?.querySelector?.("video") ?? player.el());
    }
    return document.getElementById("videoPlayerBab");
}
/**
 * Sostituisce il valore di un parametro gia' presente nel tag VAST (es. gdpr_consent=...).
 * Il legacy cercava stringhe tipo "&gdpr_consent=<vecchio>&url", che non combaciavano quando il
 * parametro era in fondo al tag: l'aggiornamento del consenso non arrivava mai ai VAST.
 */
function replaceVastParam(tagVast, paramName, newValue) {
    const pattern = new RegExp("([?&]" + paramName + "=)[^&]*", "i");
    // replacer a funzione: il valore puo' contenere "$" che in una stringa di replace ha un significato
    return tagVast.replace(pattern, (_match, prefix) => prefix + newValue);
}
//funzione che chiama il server delle analitiche
//TODO renderla dello stasso formato delle altre chiamate api?
//chiamata server analitiche
//LIB 27/08 c'è un bug vengono mandate troppe richieste
//Lorenzo ha detto di commentarlo per adesso
// async function httpCallApi(url, data) {
//   return new Promise(function (resolve, reject) {
//     $.ajax({
//       type: "POST",
//       url: burp + url,
//       data: JSON.stringify(data),
//       contentType: "application/json",
//       headers: {
//         "X-Origin-URL": window.location.href,
//       },
//       dataType: "json",
//       success: function (jsonResponse) {
//         if (jsonResponse.success == true) {
//           resolve(jsonResponse);
//         } else {
//           reject(jsonResponse);
//         }
//       },
//       error: function (data) {
//         //in caso di errore 400 pulisco il local storage delle analytiche in modo da permettere a nuovi valori di entrare
//         //altrimenti quelli errati continueranno ad essere inviati
//         if (data.status == 400) {
//           localStorage.setItem("adsAnalytics", "[]");
//         }
//       },
//     });
//   });
// }
/**
 * Ricrea il fillerGifContainer nel vecchio veniva costruito
 * prima dell'avvio delle Ads.
 */
function ensureFillerGifContainer(params, videoContent) {
    if (document.getElementById("fillerGifContainer")) {
        return;
    }
    const playerContainer = videoContent?.parentElement ??
        document.getElementById(String(params.groupsPlayerData.groupsBridID ?? ""))
            ?.parentElement ??
        null;
    if (!playerContainer) {
        return;
    }
    const fillerGifContainer = document.createElement("div");
    fillerGifContainer.id = "fillerGifContainer";
    fillerGifContainer.className = "!hidden";
    Object.assign(fillerGifContainer.style, {
        position: "absolute",
        inset: "0",
        width: "100%",
        height: "100%",
        zIndex: "4",
        background: "#000",
    });
    if (params.fillerGif) {
        const fillerGifImage = document.createElement("img");
        fillerGifImage.src = params.fillerGif;
        fillerGifImage.alt = "";
        Object.assign(fillerGifImage.style, {
            width: "100%",
            height: "100%",
            objectFit: "cover",
        });
        fillerGifContainer.appendChild(fillerGifImage);
    }
    playerContainer.insertBefore(fillerGifContainer, videoContent);
}
//LIB spostare in ads.type?
const DEALERSHIP = {
    DIGITAL_BLOOM_COMPILE: 1,
    FREEWHEEL_COMPILE: 2,
    EVOLUTIONGROUP_COMPILE: 3,
    TEADS_COMPILE: 4,
    XANDR_COMPILE: 5,
    WEBORAMA_COMPILE: 6,
};
var adsClassObject = null;
const CURRENT_DOMAIN = window.location.hostname;
let already_call_error_websocket = false;
let intervalID = null;
//Classe Ads per la gestione delle Pubblicità
export class Ads {
    /**
     * Costruttore dell'oggetto ADS
     * @param {Object} adsParams - Parametri di inizializzazione dell'oggetto ADS
     */
    constructor(player, params) {
        const videoContent = getVideoContent(player, params);
        this.onAdBlockDetected = params.onAdBlockDetected; //se viene individuato un adblock - adblock si attiva se l'ads non viene buildato correttamente
        if (!videoContent) {
            throw new Error("Impossibile inizializzare Ads: elemento video non trovato");
        }
        ensureFillerGifContainer(params, videoContent);
        const videoType = params.videoType ?? VIDEO_TYPE.VOD;
        const isLive = videoType == VIDEO_TYPE.LIVE;
        const adsCustomization = params.adsCustomization ?? {};
        const advMetadata = params.advMetadata ?? {
            contentSeries: "",
            contentGenre: "",
            contentLanguage: "",
            contentNetwork: "",
            contentAdvIsSkippable: 0,
            contentAdvMaxDuration: 0,
            contentAdvMinDuration: 0,
        };
        /**
         * TODO modificare - vedere commento su normalizeTagVast
         */
        const adsParams = {
            tagUrl: normalizeTagVast(params.tagVast),
            adsCustomizationPreRoll: isLive
                ? (adsCustomization.live_pre_roll_status ?? 0)
                : (adsCustomization.vod_pre_roll_status ?? 0),
            adsCustomizationPostRoll: isLive
                ? null
                : (adsCustomization.vod_post_roll_status ?? 0),
            adsCustomizationMidRollType: isLive
                ? (adsCustomization.live_mid_roll_type ?? 0)
                : (adsCustomization.vod_mid_roll_type ?? 0),
            adsCustomizationMidRollTimes: isLive
                ? (adsCustomization.live_mid_roll_times ?? null)
                : (adsCustomization.vod_mid_roll_times ?? null),
            player,
            relFileId: params.relFileId ?? null,
            videoContent,
            adsCountdownText: document.getElementById("countdownTextVOD"),
            adContainer: document.getElementById("adContainerVideo"),
            //hls: params.hls ?? null, //LIB 03/09/2026 serve veramente? chiede a OLA
            addrForTeads: params.addrForTeads ?? null,
            isAdsPlayingStatus: params.isAdsPlayingStatus ?? false,
            isAdsSuperAdmin: params.isAdsSuperAdmin ?? false,
            playerType: params.groupsPlayerData.groupsPlayer,
            needFullscreen: params.needFullscreen ?? false,
            duration: params.duration ?? 0,
            videoType,
            groupsAds: params.groupsAds ?? { autopromotions: [] },
            groupsNeedAutopromotion: (params.groupsAds?.autopromotions?.length ?? 0) > 0,
            playerObject: params.playerObject ?? {
                duration: params.duration ?? 0,
                goToNextVideo: params.onContentEnded ?? (() => undefined),
            },
            contentGenre: advMetadata.contentGenre ?? "",
            contentLanguage: advMetadata.contentLanguage ?? "",
            contentNetwork: advMetadata.contentNetwork ?? "",
            contentSeries: advMetadata.contentSeries ?? "",
            contentAdvIsSkippable: advMetadata.contentAdvIsSkippable ?? 0,
            contentAdvMaxDuration: String(advMetadata.contentAdvMaxDuration ?? 0),
            contentAdvMinDuration: String(advMetadata.contentAdvMinDuration ?? 0),
            i: undefined,
        };
        this.lastADSSavedOnDBDate = null;
        this.tagUrl = adsParams.tagUrl;
        this.actualTagUrl = "";
        this.numberOfAds = 1;
        this.TcData = "";
        this.tcString = "";
        this.GdprApply = 0;
        this.i = adsParams.i;
        this.completeAdsResumeAlreadyStarted = 0;
        this.preRollIterator = 0;
        this.needStopPreRollIter = 0;
        this.midRollIterator = 0;
        this.postRollIterator = 0;
        this.needStopPostRollIter = 0;
        this.liveMidRollIterator = 0;
        this.timestampVast = 0;
        this.currentAdType = ADS_ROLL_TYPE.PRE_ROLL; // Variabile che indica la tipologia di ad che soggetta alle chiamate (0 = preroll, 1 = midroll, 2 = postroll)
        this.isAdvStarted = false;
        this.tabularWaterfallIterator = 0; // Variabile che indica il numero di chiamate fatte all'interno di un ciclo waterfall (min = 0, max = Numero vast)
        this.tabularWaterfallStartPositionIterator = 0; // Iteratore per la posizione iniziale per la cascata di richieste ad tabellare
        this.firstAdvErogated = true;
        this.compilationType = 0;
        //this.hls = adsParams.hls; //LIB 03/09/2026 serve veramente? chiede a OLA
        this.fillerGif =
            document.getElementById("fillerGifContainer") !== null
                ? $("#fillerGifContainer")
                : null;
        //se l'utente ha messo muto prima della publicità non gli riattivo il volume
        this.mutedBeforeFillerGif = false;
        this.videoType = adsParams.videoType;
        this.isLive = this.videoType == VIDEO_TYPE.LIVE;
        this.videoMIMEData =
            this.videoType == VIDEO_TYPE.LIVE ? "application/x-mpegURL" : "video/mp4";
        // Dati sulle customization pubblicitari
        this.adsCustomizationPreRoll = adsParams.adsCustomizationPreRoll;
        this.adsCustomizationPostRoll = adsParams.adsCustomizationPostRoll;
        this.adsCustomizationMidRollType = adsParams.adsCustomizationMidRollType;
        this.adsCustomizationMidRollTimes = adsParams.adsCustomizationMidRollTimes;
        this.midRollFailedTimes = 0;
        this.actualTypeRollLoaded = 0;
        this.timeToCheckAdsStatusDuringLive = 2000;
        // Se la strategia di pubblicità selzionata è campionamento jingle, allora la pubblicità sarà quella tabellare
        // E' stato messo > 2 così da racchiudere tutte le strategie diverse da quella dei quadratini o quella temporizzata
        // Nel caso di implementazione di una nuova strategia, cambiare metodo di intercettazione pubblicità tabellare
        // - 0 non c'è pubblicità mid roll
        // - 1 mid roll temporizzata
        // - 2 mid roll con quadratini
        // - 3 mid roll con jingle audio
        this.adsCustomizationTabular =
            this.adsCustomizationMidRollType > 1 && this.isLive;
        this.isAdsSuperAdmin = adsParams.isAdsSuperAdmin;
        this.isAdsPlayingStatus = adsParams.isAdsPlayingStatus;
        this.relFileId = adsParams.relFileId;
        this.videoPlayer = adsParams.player;
        this.adsManager = null;
        this.adsLoader = null;
        this.adDisplayContainer = null;
        // Semaforo per gestire l'evento ads 'COMPLETED' e 'ALL_ADS_COMPLETED', evento gestito diversamente in base alla concessionaria del vast
        this.adsCompletedLaunched = false;
        this.intervalTimer = null;
        this.currTime = 0;
        this.duration = 0;
        this.videoContent = adsParams.videoContent;
        if (this.isLive == false) {
            // Nel port React/Brid currentSrc può non essere ancora valorizzato nel
            // momento esatto in cui Ads viene costruito; in quel caso manteniamo src.
            // Con Video.js non tocco l'elemento: riassegnare src fa ricaricare il video a video.js
            if (adsParams.playerType !== LIB_PLAYER.VIDEO_JS) {
                this.videoContent.src =
                    this.videoContent.currentSrc || this.videoContent.src;
            }
            this.duration = adsParams.playerObject.duration;
        }
        // ------ INFO CONTENUTO -------
        let contentTitleHTMLElement = $("#contentTitle")[0];
        this.contentTitle =
            contentTitleHTMLElement !== null && contentTitleHTMLElement !== undefined
                ? $("#contentTitle")[0].innerText.replaceAll(" ", "_")
                : "";
        this.adContainer = adsParams.adContainer;
        this.adsCountdownText = adsParams.adsCountdownText;
        this.vodLiveContainerPlyrControls = null;
        //lib ora la src gliepa sasso nei pros altrimenti è undefined
        this.source = params.videoUrl;
        this.currentAd = null;
        this.hasStartedAdsOnce = false;
        this.needToFlushBuffer = false;
        this.isFirstAdFailed = false;
        this.firstAdFailedTimer = null;
        //Numero di volte che è partita la pubblicità MidRoll Temporizzata
        this.temporizedTimes = 0;
        // ------------------ AUTOPROMOTIONS ------------------
        this.groupsHasAutopromotions = adsParams.groupsNeedAutopromotion;
        // Necessario un "semaforo" che mi annulla le reazioni agli eventi di riproduzione del player visto che non si sta riproducendo
        // una pubblicità ma un video con una nuova src
        // Autopromozione in riproduzione
        this.autoPromotionIsPlaying = false;
        // Necessaria la autopromozione nel midroll (hanno fallito tutti i vast midroll)
        this.needToPlayAutoPromotions = false;
        // Indica il numero di volte che le Autopromozioni sono state riprodotte in midroll
        this.autoPromotionMidRollPlayedTimes = 0;
        // Indica se è stata riprodotta la Autopromozione in quel roll (pre\mid\post)
        this.autoPromotionPlayed = false;
        //variabili per la gestione della piubblicità di un fast channel
        this.isFastChannelAds = false;
        if (this.groupsHasAutopromotions == true) {
            this.autopromotionsData = adsParams.groupsAds["autopromotions"];
            this.autoPromotionManager = new AdsAutopromotions(this, this.autopromotionsData);
            // conta solo le autopromo con un mp4 valido
            this.groupsHasAutopromotions =
                this.autoPromotionManager.hasAutopromotions();
        }
        // ------------------ LANNER ------------------
        this.isLannerOn = true;
        // ------------------ VIDEO DATA PER ADV ------------------
        this.contentGenre = adsParams.contentGenre.replaceAll(" ", "_");
        this.contentLanguage = adsParams.contentLanguage.replaceAll(" ", "_");
        this.contentNetwork = adsParams.contentNetwork.replaceAll(" ", "_");
        this.contentSeries = adsParams.contentSeries.replaceAll(" ", "_");
        this.contentAdvIsSkippable = adsParams.contentAdvIsSkippable;
        this.contentAdvMaxDuration =
            adsParams.contentAdvMaxDuration !== "0"
                ? adsParams.contentAdvMaxDuration
                : "30";
        this.contentAdvMinDuration =
            adsParams.contentAdvMinDuration !== "0"
                ? adsParams.contentAdvMinDuration
                : "120";
        // ----------------------------------------------------
        this.greenSquareDetectorClass = null;
        this.videoEnded = false;
        this.playerObject = adsParams.playerObject;
        this.needToStartMute = isIpad() || isIos(); //ipad e la modalità desktop dei dispositivi mobili
        this.isIphone = isIphone();
        this.midRollTimes = normalizeMidRollTimes(this.adsCustomizationMidRollTimes);
        // Il codice legacy (Brid) usa ancora adsCustomizationMidRollTimes/currentTimeToPlayAd:
        // li alimento dai tempi gia' normalizzati
        this.adsCustomizationMidRollTimes =
            this.midRollTimes.length > 0 ? this.midRollTimes : null;
        if (this.adsCustomizationMidRollType == 1) {
            this.currentTimeToPlayAd = this.midRollTimes[0];
        }
        this.vodLiveContainerPlyrControls = $(".plyr__controls");
        this.videoVolume = this.videoContent.volume;
        this.playerUnmounted = false;
        this.needFullscreen = adsParams.needFullscreen;
        this.playerTypeToBuild = adsParams.playerType;
        this.addrForTeads =
            typeof IP_ADDRESS !== "undefined" &&
                IP_ADDRESS !== null &&
                IP_ADDRESS !== ""
                ? IP_ADDRESS
                : adsParams.addrForTeads;
        this.videoJsAds = null;
        this.bridJsAds = null;
        this.plyrJsAds = null;
        switch (this.playerTypeToBuild) {
            case LIB_PLAYER.BRID_PLAYER:
                this.bridJsAds = new AdsBridJs(this);
                break;
            case LIB_PLAYER.VIDEO_JS:
                this.videoJsAds = new AdsVideoJs(this);
                break;
            case LIB_PLAYER.PLYR:
                // AdsPlyrJs non è presente nei sorgenti forniti. Il valore viene
                // mantenuto per compatibilità con LIB_PLAYER, ma questo port supporta
                // in modo completo Video.js e Brid come richiesto.
                console.warn("AdsPlyrJs non disponibile nel port React");
                break;
            default:
                break;
        }
        if (this.playerTypeToBuild !== LIB_PLAYER.VIDEO_JS) {
            setTimeout(() => {
                this.cycleAndCompileAllTagVast();
                this.adsInitializer();
                if (this.videoEnded == false) {
                    if (this.playerTypeToBuild == LIB_PLAYER.BRID_PLAYER) {
                        this.videoPlayer.play?.();
                    }
                    else {
                        this.videoContent.play();
                    }
                }
            }, Time_Sleep_Restart_Standard);
        }
        adsClassObject = this;
        this.tagVastTypeBrid = 0;
        //TIPO PUBBLICITA' PREROLL 'default' POSTROLL 0 MIDROLL TEMPORIZZATO 1 MIDROLL SUONO 2 MIDROLL QUADRATINI 3
        //ARRAY DI MINUTI - QUANDO IL PLAYER E' IN ESECUZIONE, IL CONTROLLO OGNI SECONDO SE IL TEMPO CORRENTE E' PARI AD UNO DEI VALORI DEI TEMPI DELL'ARRAY
        //BOOLEANO VIDEO IN PAUSA - QUANDO SI STOPPA TRUE, ALTRIMENTI FALSE (SERVE PER VALORE COMPUTAZIONALE E STOPPARE TUTTI I CONTROLLI)
        // Live con pubblicita' tabellare (is_ads_playing): con Video.js i CUE HLS del manifest sono la
        // fonte principale e il websocket fa da fallback finche' nel manifest non compare un cue tag
        // (a quel punto AdsVideoJs lo chiude). Il polling verso il server GO non serve piu'.
        this.isSocketConnected = false;
        this.socket = null;
        if (this.adsCustomizationTabular == true &&
            this.playerTypeToBuild == LIB_PLAYER.VIDEO_JS) {
            this.filesLiveID =
                document.getElementById("dtRl")?.getAttribute("rel") ??
                    String(this.relFileId ?? "");
            this.startSocketPolling();
        }
        // if (
        //   this.adsCustomizationTabular == true &&
        //   WEB_SOCKET_URL !== "" &&
        //   typeof WEB_SOCKET_URL !== "undefined"
        // ) {
        //   // Raccolta id Live dal div 'dtRL'
        //   this.filesLiveID =
        //     document.getElementById("dtRl")?.getAttribute("rel") ??
        //     String(this.relFileId ?? "");
        //   // Inizializzo lo status della connessione socket
        //   this.isSocketConnected = false;
        //   this.startSocketPolling();
        // }
        window.adsForVideoPlayer = this;
        //timer che gestisce l'invio delle analytiche
        this.analyticsTimer = setInterval(this.sendAnalitycs.bind(this), Time_Analytics_Sender_Interval);
    }
    /**
     *
     * @returns {Boolean} True: Il video è in pausa. False: Il video è in riproduzione
     */
    getVideoEndedstatus() {
        return this.videoEnded;
    }
    /**
     * Applica una trasformazione a tutti i tag vast di pre, mid e post-roll
     * @param {Function} callback - (tagVast, compilationType) => nuovo tagVast
     */
    forEachTagVast(callback) {
        ["pre_roll", "mid_roll", "post_roll"].forEach((rollKey) => {
            (this.tagUrl[rollKey] ?? []).forEach((tagVastData) => {
                if (typeof tagVastData.tag_vast === "string") {
                    tagVastData.tag_vast = callback(tagVastData.tag_vast, tagVastData.vast_compilation_type);
                }
            });
        });
    }
    /**
     * Aggiorna i dati TcString per i tag vast
     * @param {String} newTcString
     */
    changeTagVastTcString(newTcString) {
        if (newTcString == null ||
            newTcString === "" ||
            this.tcString === newTcString) {
            return;
        }
        this.forEachTagVast((tagVast, compilationType) => {
            switch (compilationType) {
                case DEALERSHIP.EVOLUTIONGROUP_COMPILE:
                    // Evolution puo' avere sia le macro AV_* sia il formato doubleclick
                    return replaceVastParam(replaceVastParam(tagVast, "AV_CONSENT", newTcString), "gdpr_consent", newTcString);
                case DEALERSHIP.FREEWHEEL_COMPILE:
                    return replaceVastParam(tagVast, "_fw_gdpr_consent", newTcString);
                default:
                    return replaceVastParam(tagVast, "gdpr_consent", newTcString);
            }
        });
        this.tcString = newTcString;
    }
    /**
     * Aggiorna i dati TcData per i tag vast
     * @param {String} newTcData
     */
    changeTagVastTcData(newTcData) {
        if (newTcData == null || newTcData === "" || this.TcData === newTcData) {
            return;
        }
        this.forEachTagVast((tagVast, compilationType) => compilationType == DEALERSHIP.EVOLUTIONGROUP_COMPILE
            ? replaceVastParam(tagVast, "AV_SCHAIN", newTcData)
            : tagVast);
        this.TcData = newTcData;
    }
    /**
     * Aggiorna i dati gdpr per i tag vast
     * @param {String} gdprApply
     */
    changeTagVastGdprApply(gdprApply) {
        if (gdprApply === true) {
            gdprApply = 1;
        }
        else if (gdprApply === false) {
            gdprApply = 0;
        }
        // prima il confronto era con this.gdprApply (mai valorizzato) invece di this.GdprApply
        if (gdprApply == null || gdprApply === "" || this.GdprApply === gdprApply) {
            return;
        }
        this.forEachTagVast((tagVast, compilationType) => {
            switch (compilationType) {
                case DEALERSHIP.EVOLUTIONGROUP_COMPILE:
                    return replaceVastParam(replaceVastParam(tagVast, "AV_GDPR", gdprApply), "gdpr", gdprApply);
                case DEALERSHIP.FREEWHEEL_COMPILE:
                    return replaceVastParam(tagVast, "_fw_gdpr", gdprApply);
                default:
                    return replaceVastParam(tagVast, "gdpr", gdprApply);
            }
        });
        this.GdprApply = gdprApply;
    }
    /**
     * Compilazione ciclica di tutti i vast
     */
    cycleAndCompileAllTagVast() {
        let preRollVastLength = this.tagUrl["pre_roll"].length;
        let midRollVastLength = this.tagUrl["mid_roll"].length;
        let postRollVastLength = this.tagUrl["post_roll"].length;
        for (let i = 0; i < preRollVastLength; i++) {
            switch (this.tagUrl["pre_roll"][i]["vast_compilation_type"]) {
                case DEALERSHIP.DIGITAL_BLOOM_COMPILE:
                    this.tagUrl["pre_roll"][i]["tag_vast"] =
                        this.compileGdprVastDigitalBloom(this.tagUrl["pre_roll"][i]["tag_vast"], "preroll");
                    break;
                case DEALERSHIP.FREEWHEEL_COMPILE:
                    this.tagUrl["pre_roll"][i]["tag_vast"] =
                        this.compileGdprVastFreeWheel(this.tagUrl["pre_roll"][i]);
                    break;
                case DEALERSHIP.EVOLUTIONGROUP_COMPILE:
                    this.tagUrl["pre_roll"][i]["tag_vast"] =
                        this.compileGdprVastEvolutionGroup(this.tagUrl["pre_roll"][i]["tag_vast"], "preroll");
                    break;
                case DEALERSHIP.TEADS_COMPILE:
                    this.tagUrl["pre_roll"][i]["tag_vast"] = this.compileGdprVastTeads(this.tagUrl["pre_roll"][i]["tag_vast"], "preroll");
                    break;
                case DEALERSHIP.XANDR_COMPILE:
                    this.tagUrl["pre_roll"][i]["tag_vast"] = this.compileGdprVastXandr(this.tagUrl["pre_roll"][i]["tag_vast"], "preroll");
                    break;
                case DEALERSHIP.WEBORAMA_COMPILE:
                    this.tagUrl["pre_roll"][i]["tag_vast"] = this.compileWeborama(this.tagUrl["pre_roll"][i]["tag_vast"], "preroll");
                    break;
                default:
                    this.tagUrl["pre_roll"][i]["tag_vast"] =
                        this.compileGdprVastDigitalBloom(this.tagUrl["pre_roll"][i]["tag_vast"], "preroll");
                    break;
            }
        }
        for (let i = 0; i < midRollVastLength; i++) {
            switch (this.tagUrl["mid_roll"][i]["vast_compilation_type"]) {
                case DEALERSHIP.DIGITAL_BLOOM_COMPILE:
                    this.tagUrl["mid_roll"][i]["tag_vast"] =
                        this.compileGdprVastDigitalBloom(this.tagUrl["mid_roll"][i]["tag_vast"], "midroll");
                    break;
                case DEALERSHIP.FREEWHEEL_COMPILE:
                    this.tagUrl["mid_roll"][i]["tag_vast"] =
                        this.compileGdprVastFreeWheel(this.tagUrl["mid_roll"][i]);
                    break;
                case DEALERSHIP.EVOLUTIONGROUP_COMPILE:
                    this.tagUrl["mid_roll"][i]["tag_vast"] =
                        this.compileGdprVastEvolutionGroup(this.tagUrl["mid_roll"][i]["tag_vast"], "midroll");
                    break;
                case DEALERSHIP.TEADS_COMPILE:
                    this.tagUrl["mid_roll"][i]["tag_vast"] = this.compileGdprVastTeads(this.tagUrl["mid_roll"][i]["tag_vast"], "midroll");
                    break;
                case DEALERSHIP.XANDR_COMPILE:
                    this.tagUrl["mid_roll"][i]["tag_vast"] = this.compileGdprVastXandr(this.tagUrl["mid_roll"][i]["tag_vast"], "midroll");
                    break;
                case DEALERSHIP.WEBORAMA_COMPILE:
                    this.tagUrl["mid_roll"][i]["tag_vast"] = this.compileWeborama(this.tagUrl["mid_roll"][i]["tag_vast"], "midroll");
                    break;
                default:
                    this.tagUrl["mid_roll"][i]["tag_vast"] =
                        this.compileGdprVastDigitalBloom(this.tagUrl["mid_roll"][i]["tag_vast"], "midroll");
                    break;
            }
        }
        for (let i = 0; i < postRollVastLength; i++) {
            switch (this.tagUrl["post_roll"][i]["vast_compilation_type"]) {
                case DEALERSHIP.DIGITAL_BLOOM_COMPILE:
                    this.tagUrl["post_roll"][i]["tag_vast"] =
                        this.compileGdprVastDigitalBloom(this.tagUrl["post_roll"][i]["tag_vast"], "postroll");
                    break;
                case DEALERSHIP.FREEWHEEL_COMPILE:
                    this.tagUrl["post_roll"][i]["tag_vast"] =
                        this.compileGdprVastFreeWheel(this.tagUrl["post_roll"][i]);
                    break;
                case DEALERSHIP.EVOLUTIONGROUP_COMPILE:
                    this.tagUrl["post_roll"][i]["tag_vast"] =
                        this.compileGdprVastEvolutionGroup(this.tagUrl["post_roll"][i]["tag_vast"], "postroll");
                    break;
                case DEALERSHIP.TEADS_COMPILE:
                    this.tagUrl["post_roll"][i]["tag_vast"] = this.compileGdprVastTeads(this.tagUrl["post_roll"][i]["tag_vast"], "postroll");
                    break;
                case DEALERSHIP.XANDR_COMPILE:
                    this.tagUrl["post_roll"][i]["tag_vast"] = this.compileGdprVastXandr(this.tagUrl["post_roll"][i]["tag_vast"], "postroll");
                    break;
                case DEALERSHIP.WEBORAMA_COMPILE:
                    this.tagUrl["post_roll"][i]["tag_vast"] = this.compileWeborama(this.tagUrl["post_roll"][i]["tag_vast"], "postroll");
                    break;
                default:
                    this.tagUrl["post_roll"][i]["tag_vast"] =
                        this.compileGdprVastDigitalBloom(this.tagUrl["post_roll"][i]["tag_vast"], "postroll");
                    break;
            }
        }
    }
    /**
     * Compilazione del vast per concessionaria Digital Bloom
     * @param {String} tagVast
     * @param {String} adTypeVPOSString
     * @returns {String} Stringa Tag Vast compilato con parametri aggiuntivi
     */
    compileGdprVastDigitalBloom(tagVast, adTypeVPOSString) {
        this.timestampVast = Date.now();
        tagVast = tagVast.replace("&correlator=[timestamp]&", "&correlator=" + this.timestampVast + "&");
        tagVast = tagVast.replace("&url=[placeholder_url]", "&url=" + window.location.href);
        let gdprAppliesH = tcStringGDPR !== null &&
            tcStringGDPR !== "" &&
            tcStringGDPR !== undefined &&
            typeof tcStringGDPR !== "undefined"
            ? 1
            : 0;
        let tcStringGDPRH = "";
        let gdpr = tcStringGDPR !== null &&
            tcStringGDPR !== "" &&
            tcStringGDPR !== undefined &&
            typeof tcStringGDPR !== "undefined"
            ? gdprApplies
            : gdprAppliesH;
        let tcString = tcStringGDPR !== null &&
            tcStringGDPR !== "" &&
            tcStringGDPR !== undefined &&
            typeof tcStringGDPR !== "undefined"
            ? tcStringGDPR
            : tcStringGDPRH;
        return (tagVast +
            "&ad_type=video&plcmt=1&wta=1&vpmute=1&vpa=click&vpos=" +
            adTypeVPOSString +
            "&gdpr=" +
            gdpr +
            "&gdpr_consent=" +
            tcString);
    }
    /**
     * Compilazione del vast per concessionaria Evolution Group
     * @param {String} tagVast
     * @param {String} adTypeVPOSString
     * @returns {String} Stringa Tag Vast compilato con parametri aggiuntivi
     */
    compileGdprVastEvolutionGroup(tagVast, adTypeVPOSString) {
        this.timestampVast = Date.now();
        if (tagVast.includes("&cb=[TIMESTAMP_MACRO]&")) {
            tagVast = tagVast.replace("&cb=[TIMESTAMP_MACRO]&", "&cb=" + this.timestampVast + "&");
            tagVast = tagVast.replace("&AV_URL=[URL_MACRO]&", "&AV_URL=" + window.location.href + "&");
            let gdprAppliesH = tcStringGDPR !== null &&
                tcStringGDPR !== "" &&
                tcStringGDPR !== undefined &&
                typeof tcStringGDPR !== "undefined"
                ? 1
                : 0;
            let tcStringGDPRH = "";
            let gdpr = tcStringGDPR !== null &&
                tcStringGDPR !== "" &&
                tcStringGDPR !== undefined &&
                typeof tcStringGDPR !== "undefined"
                ? gdprApplies
                : gdprAppliesH;
            let tcString = tcStringGDPR !== null &&
                tcStringGDPR !== "" &&
                tcStringGDPR !== undefined &&
                typeof tcStringGDPR !== "undefined"
                ? tcStringGDPR
                : tcStringGDPRH;
            tagVast = tagVast.replace("&AV_SCHAIN=[SCHAIN_MACRO]&", "&AV_SCHAIN=" + tcString + "&");
            tagVast = tagVast.replace("&AV_GDPR=[GDPR_MACRO]&", "&AV_GDPR=" + gdpr + "&");
            tagVast = tagVast.replace("&AV_CONSENT=[CONSENT_MACRO]", "&AV_CONSENT=" + tcString + "");
        }
        else if (tagVast.includes("pubads.g.doubleclick.net")) {
            this.timestampVast = Date.now();
            tagVast = tagVast.replace("&correlator=[timestamp]&", "&correlator=" + this.timestampVast + "&");
            tagVast = tagVast.replace("&url=[placeholder_url]&", "&url=" + window.location.href + "&");
            let gdprAppliesH = tcStringGDPR !== null &&
                tcStringGDPR !== "" &&
                tcStringGDPR !== undefined &&
                typeof tcStringGDPR !== "undefined"
                ? 1
                : 0;
            let tcStringGDPRH = "";
            let gdpr = tcStringGDPR !== null &&
                tcStringGDPR !== "" &&
                tcStringGDPR !== undefined &&
                typeof tcStringGDPR !== "undefined"
                ? gdprApplies
                : gdprAppliesH;
            let tcString = tcStringGDPR !== null &&
                tcStringGDPR !== "" &&
                tcStringGDPR !== undefined &&
                typeof tcStringGDPR !== "undefined"
                ? tcStringGDPR
                : tcStringGDPRH;
            return tagVast + "&gdpr=" + gdpr + "&gdpr_consent=" + tcString;
        }
        else {
            tagVast = tagVast.replace("&correlator=[AV_TIMESTAMP]", "&correlator=" + this.timestampVast);
            let gdprAppliesH = tcStringGDPR !== null &&
                tcStringGDPR !== "" &&
                tcStringGDPR !== undefined &&
                typeof tcStringGDPR !== "undefined"
                ? 1
                : 0;
            let tcStringGDPRH = "";
            let gdpr = tcStringGDPR !== null &&
                tcStringGDPR !== "" &&
                tcStringGDPR !== undefined &&
                typeof tcStringGDPR !== "undefined"
                ? gdprApplies
                : gdprAppliesH;
            let tcString = tcStringGDPR !== null &&
                tcStringGDPR !== "" &&
                tcStringGDPR !== undefined &&
                typeof tcStringGDPR !== "undefined"
                ? tcStringGDPR
                : tcStringGDPRH;
            tagVast =
                tagVast +
                    "&ad_type=video&plcmt=1&wta=1&vpmute=1&vpa=click&vpos=" +
                    adTypeVPOSString +
                    "&gdpr=" +
                    gdpr +
                    "&gdpr_consent=" +
                    tcString;
        }
        return tagVast;
    }
    /**
     * Compilazione del vast per concessionaria FreeWheel
     * @param {String} tagVast
     * @param {String} adTypeVPOSString
     * @returns {String} Stringa Tag Vast compilato con parametri aggiuntivi
     */
    compileGdprVastFreeWheel(tagVastDatas) {
        // _fw_inventorypartnerdomain
        let appDomain = CURRENT_DOMAIN;
        let tagVast = tagVastDatas["tag_vast"];
        // _fw_h_user_agent
        let userAgent = this.uuid();
        let contentNetwork = this.contentNetwork;
        let contentAdvMaxDuration = this.contentAdvMaxDuration;
        let contentAdvMinDuration = this.contentAdvMinDuration;
        // _fw_h_referer
        let referer = window.location.href;
        let sitePage = window.location.origin;
        // _fw_did
        let devideID = "";
        // _fw_platform
        let platform = "";
        // _fw_platform_weborapp
        let weborapp = "";
        // Se mobile Android
        if (isMobile() == true) {
            devideID = "google_advertising_id";
            platform = "Mobile";
            weborapp = "mobile_web";
        }
        // Se Mobile Iphone or Ipad
        else if (this.isIphone || isIpad()) {
            devideID = "idfa";
            platform = "Mobile";
            weborapp = "mobile_web";
        }
        // Altrimenti Windows
        else {
            devideID = "windows_advertising_id";
            platform = "Desktop";
        }
        // _fw_player_width
        let videoWidth = this.videoContent.videoWidth > 0 ? this.videoContent.videoWidth : 1280;
        // _fw_player_height
        let videoHeight = this.videoContent.videoHeight > 0 ? this.videoContent.videoHeight : 720;
        // _fw_content_length
        let contentLength = this.isLive == true ? 0 : parseInt(this.videoContent.duration);
        // _fw_content_language
        let contentLanguage = this.contentLanguage;
        // _fw_content_genre
        let contentGenre = this.contentGenre;
        // _fw_is_lat
        let isLatValue = "1";
        // _fw_content_title
        let contentTitle = this.contentTitle;
        // Schain parameters
        let publishersId = tagVastDatas["publishers_id"];
        let publishersDomain = tagVastDatas["publishers_domain"];
        // let profValue = "536147:fw_ssp_babyloncloudnetwork_web-webmobile-js";
        let contentLivestream = this.isLive == true ? "live" : "on-demand";
        let siteLanguage = this.isLive == true ? "it" : contentLanguage;
        // --- INIZIO COMPILAZIONE VAST ---
        // resp
        tagVast = tagVast.replace("resp={resp-type}", "resp=vast2");
        //_fw_inventorypartnerdomain
        tagVast = tagVast.replace("_fw_inventorypartnerdomain={3rd-party-macro}", "_fw_inventorypartnerdomain=" + appDomain);
        //_fw_h_user_agent
        tagVast = tagVast.replace("_fw_h_user_agent={3rd-party-macro}", "_fw_h_user_agent=" + userAgent);
        //_fw_h_referer
        tagVast = tagVast.replace("_fw_h_referer={3rd-party-macro}", "_fw_h_referer=" + referer);
        //_fw_site_page
        tagVast = tagVast.replace("_fw_site_page={3rd-party-macro}", "_fw_site_page=" + sitePage);
        //_fw_did
        tagVast = tagVast.replace("_fw_did={3rd-party-macro}", "_fw_did=" + devideID);
        //_fw_platform
        tagVast = tagVast.replace("_fw_platform={3rd-party-macro}", "_fw_platform=" + platform);
        // _fw_platform_weborapp
        tagVast = tagVast.replace("_fw_platform_weborapp={3rd-party-macro}", "_fw_platform_weborapp=web");
        // _fw_content_title
        contentTitle !== null && contentTitle !== "" && contentTitle !== undefined
            ? (tagVast = tagVast.replace("_fw_content_title={3rd-party-macro}", "_fw_content_title=" + contentTitle))
            : (tagVast = tagVast.replace("_fw_content_title={3rd-party-macro}", ""));
        let tagVastSchain = this.compileSchain(publishersId, publishersDomain);
        //schain
        tagVast = tagVast.replace("schain={schain-value}", "schain=" + tagVastSchain);
        //_fw_content_length
        contentLength > 0 // Se è un vod, inserisco la duration, altrimenti rimuovo la marco '_fw_content_length'
            ? (tagVast = tagVast.replace("_fw_content_length={3rd-party-macro}", "_fw_content_length=" + contentLength))
            : (tagVast = tagVast.replace("_fw_content_length={3rd-party-macro}&", ""));
        // _fw_player_width
        tagVast = tagVast.replace("_fw_player_width={3rd-party-macro}", "_fw_player_width=" + videoWidth);
        // _fw_player_height
        tagVast = tagVast.replace("_fw_player_height={3rd-party-macro}", "_fw_player_height=" + videoHeight);
        //_fw_content_language
        tagVast = tagVast.replace("_fw_content_language={3rd-party-macro}", "_fw_content_language=" + siteLanguage);
        //_fw_content_category
        // tagVast = tagVast.replace("_fw_content_category={3rd-party-macro}", "_fw_content_category=" + contentGenre);
        tagVast = tagVast.replace("_fw_content_category={3rd-party-macro}", "_fw_content_category=");
        //_fw_site_category
        // tagVast = tagVast.replace("_fw_site_category={3rd-party-macro}", "_fw_site_category=" + contentGenre);
        tagVast = tagVast.replace("_fw_site_category={3rd-party-macro}", "_fw_site_category=");
        //_fw_content_genre
        // tagVast = tagVast.replace("_fw_content_genre={3rd-party-macro}", "_fw_content_genre=" + contentGenre);
        tagVast = tagVast.replace("_fw_content_genre={3rd-party-macro}", "_fw_content_genre=");
        // _fw_is_lat
        tagVast = tagVast.replace("_fw_is_lat={3rd-party-macro}", "_fw_is_lat=" + isLatValue);
        // mode
        tagVast = tagVast.replace("mode={value}", "mode=" + contentLivestream);
        // vip
        tagVast = tagVast.replace("vip={3rd-party-macro}", "vip=" + this.addrForTeads);
        // _fw_content_producer_name
        tagVast = tagVast.replace("_fw_content_producer_name={3rd-party-macro}", "_fw_content_producer_name=" + contentNetwork);
        // maxd
        tagVast = tagVast.replace("maxd={3rd-party-macro}", "maxd=" + contentAdvMaxDuration);
        // mind
        tagVast = tagVast.replace("mind={3rd-party-macro}", "mind=" + contentAdvMinDuration);
        // Raccolta info per macro 'gdpr' & gdpr_consent'
        let gdprAppliesH = tcStringGDPR !== null &&
            tcStringGDPR !== "" &&
            tcStringGDPR !== undefined &&
            typeof tcStringGDPR !== "undefined"
            ? 1
            : 0;
        let tcStringGDPRH = "";
        // _fw_gdpr
        let gdpr = tcStringGDPR !== null &&
            tcStringGDPR !== "" &&
            tcStringGDPR !== undefined &&
            typeof tcStringGDPR !== "undefined"
            ? gdprApplies
            : gdprAppliesH;
        tagVast = tagVast.replace("_fw_gdpr={3rd-party-macro}", "_fw_gdpr=" + gdpr);
        // _fw_gdpr_consent
        let tcString = tcStringGDPR !== null &&
            tcStringGDPR !== "" &&
            tcStringGDPR !== undefined &&
            typeof tcStringGDPR !== "undefined"
            ? tcStringGDPR
            : tcStringGDPRH;
        tagVast = tagVast.replace("_fw_gdpr_consent={3rd-party-macro}", "_fw_gdpr_consent=" + tcString);
        // Aggiunta macro 'gdpr' & 'gdpr_consent' e return della stringa completa
        return tagVast;
    }
    /**
     * Compilazione del vast per concessionaria Teads
     * @param {String} tagVast
     * @param {String} adTypeVPOSString
     * @returns {String} Stringa Tag Vast compilato con parametri aggiuntivi
     */
    compileGdprVastTeads(tagVast, adTypeVPOSString) {
        let addrForTeads = this.addrForTeads;
        let placementType = 1;
        let playbackType = 1;
        let videoWidth = this.videoContent.videoWidth > 0 ? this.videoContent.videoWidth : 1280;
        let videoHeight = this.videoContent.videoHeight > 0 ? this.videoContent.videoHeight : 720;
        let googleAdsID = "9204256889"; // Hardcoded, valore preso da Settings->Account information da dashboard di Google Adsense
        let apiFramework = "2";
        let referer = window.location.href;
        let pageReferer = "";
        if (document.referrer && document.referrer !== "") {
            pageReferer = document.referrer;
        }
        let appDomain = CURRENT_DOMAIN;
        let allowedMimes = this.videoMIMEData;
        let contentLivestream = this.videoType;
        let contentContext = 1;
        let contentGenre = this.contentGenre;
        let contentLanguage = this.contentLanguage;
        let contentTitle = this.contentTitle;
        let contentLength = this.isLive == true ? 0 : this.duration;
        let contentNetwork = this.contentNetwork;
        let contentSeries = this.contentSeries;
        // (Per ora ci metto questo, poi con il nuovo sviluppo admin 2.0 ci sarà la nuova versione di questi dati)
        let contentKeywords = this.contentGenre;
        let contentAdvIsSkippable = this.contentAdvIsSkippable;
        let contentAdvMaxDuration = this.contentAdvMaxDuration;
        let contentAdvMinDuration = this.contentAdvMinDuration;
        let teadsUserAgent = this.uuid();
        tagVast = tagVast.replace("[USERAGENT]", teadsUserAgent);
        tagVast = tagVast.replace("[DEVICEID]", googleAdsID);
        tagVast = tagVast.replace("[PLAYER_HEIGHT]", videoHeight);
        tagVast = tagVast.replace("[PLAYER_WIDTH]", videoWidth);
        tagVast = tagVast.replace("[IP_ADDRESS]", addrForTeads);
        tagVast = tagVast.replace("[PLAYBACK_METHOD]", playbackType);
        tagVast = tagVast.replace("[PLACEMENT_TYPE]", placementType);
        tagVast = tagVast.replace("[API]", apiFramework);
        tagVast = tagVast.replace("[PAGE_REFERER]", pageReferer);
        tagVast = tagVast.replace("[REFERER]", referer);
        tagVast = tagVast.replace("[APPDOMAIN]", appDomain);
        tagVast = tagVast.replace("[MIMES]", allowedMimes);
        tagVast = tagVast.replace("[CONTENT_LIVESTREAM]", contentLivestream);
        tagVast = tagVast.replace("[CONTENT_CONTEXT]", contentContext);
        tagVast = tagVast.replace("[CONTENT_TITLE]", contentTitle);
        tagVast = tagVast.replace("[CONTENT_NETWORK]", contentNetwork);
        tagVast = tagVast.replace("[CONTENT_KEYWORDS]", contentKeywords);
        tagVast = tagVast.replace("[SKIP]", contentAdvIsSkippable);
        tagVast = tagVast.replace("[MAX_DURATION]", contentAdvMaxDuration);
        tagVast = tagVast.replace("[MIN_DURATION]", contentAdvMinDuration);
        contentGenre !== "" && typeof contentGenre !== "undefined"
            ? (tagVast = tagVast.replace("[CONTENT_GENRE]", contentGenre))
            : (tagVast = tagVast.replace("[CONTENT_GENRE]", ""));
        contentLanguage !== "" && typeof contentLanguage !== "undefined"
            ? (tagVast = tagVast.replace("[CONTENT_LANGUAGE]", contentLanguage))
            : (tagVast = tagVast.replace("[CONTENT_LANGUAGE]", ""));
        contentSeries !== "" && typeof contentSeries !== "undefined"
            ? (tagVast = tagVast.replace("[CONTENT_SERIES]", contentSeries))
            : (tagVast = tagVast.replace("[CONTENT_SERIES]", ""));
        contentLength !== "" &&
            typeof contentLength !== "undefined" &&
            contentLength > 0
            ? (tagVast = tagVast.replace("[CONTENT_LENGTH]", contentLength))
            : (tagVast = tagVast.replace("[CONTENT_LENGTH]", ""));
        let gdprAppliesH = tcStringGDPR !== null &&
            tcStringGDPR !== "" &&
            tcStringGDPR !== undefined &&
            typeof tcStringGDPR !== "undefined"
            ? 1
            : 0;
        let tcStringGDPRH = "";
        let gdpr = tcStringGDPR !== null &&
            tcStringGDPR !== "" &&
            tcStringGDPR !== undefined &&
            typeof tcStringGDPR !== "undefined"
            ? gdprApplies
            : gdprAppliesH;
        let tcString = tcStringGDPR !== null &&
            tcStringGDPR !== "" &&
            tcStringGDPR !== undefined &&
            typeof tcStringGDPR !== "undefined"
            ? tcStringGDPR
            : tcStringGDPRH;
        return (tagVast +
            "&ad_type=video&plcmt=1&wta=1&vpmute=1&vpa=click&vpos=" +
            adTypeVPOSString +
            "&gdpr=" +
            gdpr +
            "&gdpr_consent=" +
            tcString);
    }
    /**
     * Compilazione del vast per concessionaria Xandr
     * @param {String} tagVast
     * @param {String} adTypeVPOSString
     * @returns {String} Stringa Tag Vast compilato con parametri aggiuntivi
     */
    compileGdprVastXandr(tagVast, adTypeVPOSString) {
        let numRandForCachebusterMacro = Math.floor(Math.random() * 100000) + 1;
        tagVast = tagVast.replace("&cb=[CACHEBUSTER]", "&cb=" + numRandForCachebusterMacro);
        let gdprAppliesH = tcStringGDPR !== null &&
            tcStringGDPR !== "" &&
            tcStringGDPR !== undefined &&
            typeof tcStringGDPR !== "undefined"
            ? 1
            : 0;
        let tcStringGDPRH = "";
        let gdpr = tcStringGDPR !== null &&
            tcStringGDPR !== "" &&
            tcStringGDPR !== undefined &&
            typeof tcStringGDPR !== "undefined"
            ? gdprApplies
            : gdprAppliesH;
        let tcString = tcStringGDPR !== null &&
            tcStringGDPR !== "" &&
            tcStringGDPR !== undefined &&
            typeof tcStringGDPR !== "undefined"
            ? tcStringGDPR
            : tcStringGDPRH;
        return (tagVast +
            "&ad_type=video&plcmt=1&wta=1&vpmute=1&vpa=click&vpos=" +
            adTypeVPOSString +
            "&gdpr=" +
            gdpr +
            "&gdpr_consent=" +
            tcString);
    }
    /**
     * Compilazione della macro 'schain' utile a FreeWheel per capire su quale publisher si sta facendo ad request (publishers_id è stesso valore su sellers.json)
     * @param {String} publishersId
     * @param {String} publishersDomain
     * @returns
     */
    compileSchain(publishersId, publishersDomain) {
        // let schainString = "1.0,complete=1!";
        let schainString = "1.0,1!";
        // return schainString + "asi=" + publishersDomain + ",sid=" + publishersId + ",hp=1!asi=freewheel.tv,sid=536147,hp=1";
        return schainString + "babyloncloud.com," + publishersDomain + ",1,,,";
    }
    /**
     * Compilazione per i vast di Weborama
     * @param {*} tagVast
     * @param {*} adTypeVPOSString
     * @returns
     */
    compileWeborama(tagVast, adTypeVPOSString) {
        // Numero randomico da mettere nella macro 'a.ra'
        let numRandForRandomMacro = Math.floor(Math.random() * 100000) + 1;
        let gdprAppliesH = tcStringGDPR !== null &&
            tcStringGDPR !== "" &&
            tcStringGDPR !== undefined &&
            typeof tcStringGDPR !== "undefined"
            ? 1
            : 0;
        let tcStringGDPRH = "";
        let gdpr = tcStringGDPR !== null &&
            tcStringGDPR !== "" &&
            tcStringGDPR !== undefined &&
            typeof tcStringGDPR !== "undefined"
            ? gdprApplies
            : gdprAppliesH;
        let tcString = tcStringGDPR !== null &&
            tcStringGDPR !== "" &&
            tcStringGDPR !== undefined &&
            typeof tcStringGDPR !== "undefined"
            ? tcStringGDPR
            : tcStringGDPRH;
        tagVast = tagVast.replace("&a.ra=[RANDOM]", "&a.ra=" + numRandForRandomMacro);
        tagVast = tagVast.replace("&gdpr=${GDPR}&", "&gdpr=" + gdpr);
        tagVast = tagVast.replace("&gdpr_consent=${GDPR_CONSENT_284}&", "&gdpr_consent=" + tcString);
        return tagVast + gdpr + "&gdpr_consent=" + tcString;
    }
    /**
     * Gestisce quale tag vast utilizzare secondo quale strategia adoperare, se preroll, midroll o postroll - PER LE LIVE
     * @returns {String} Stringa Tag Vast da utilizzare per l'ad break
     */
    getVastForLive() {
        let tagVast = "";
        let preRollVastLength = this.tagUrl["pre_roll"].length;
        // PRE-ROLL
        if (this.adsCustomizationPreRoll === 1 && this.needStopPreRollIter == 0) {
            if (preRollVastLength > 0 && this.preRollIterator < preRollVastLength) {
                tagVast = this.tagUrl["pre_roll"][this.preRollIterator]["tag_vast"];
                this.numberOfAds =
                    this.tagUrl["pre_roll"][this.preRollIterator]["number_of_ads"];
                this.compilationType =
                    this.tagUrl["pre_roll"][this.preRollIterator]["vast_compilation_type"];
                this.preRollIterator = this.preRollIterator + 1;
                this.actualTypeRollLoaded = ADS_ROLL_TYPE.PRE_ROLL;
                return tagVast;
            }
            else {
                if (this.groupsHasAutopromotions == true &&
                    this.autoPromotionPlayed == false) {
                    this.needToPlayAutoPromotions = true;
                    tagVast = this.autoPromotionManager.getAutoPromotionSource();
                    return tagVast;
                }
                else {
                    this.adsCustomizationPreRoll = 0;
                    this.needStopPreRollIter = 1;
                    if (this.playerTypeToBuild == LIB_PLAYER.VIDEO_JS) {
                        this.videoJsAds?.delaySeekLive();
                    }
                }
            }
        }
        else {
            this.adsCustomizationPreRoll = 0;
            this.needStopPreRollIter = 1;
        }
        // MID-ROLL
        let midRollVastLength = this.tagUrl["mid_roll"].length;
        let midRollTimesLength = this.adsCustomizationMidRollTimes == null
            ? 0
            : this.adsCustomizationMidRollTimes.length;
        if (this.currentAdType == ADS_ROLL_TYPE.PRE_ROLL) {
            this.currentAdType = 1;
            this.videoJsAds?.setSizeLoad();
        }
        if (this.adsCustomizationTabular == true ||
            (midRollTimesLength > 0 && this.temporizedTimes < midRollTimesLength)) {
            if (midRollVastLength > 0 &&
                this.midRollFailedTimes < midRollVastLength) {
                if (this.midRollIterator >= midRollVastLength) {
                    this.midRollIterator = 0;
                }
                tagVast = this.tagUrl["mid_roll"][this.midRollIterator]["tag_vast"];
                this.numberOfAds =
                    this.tagUrl["mid_roll"][this.midRollIterator]["number_of_ads"];
                let vastCompilationType = this.tagUrl["mid_roll"][this.midRollIterator]["vast_compilation_type"];
                tagVast = this.incrementMidRollLiveVastIterator(tagVast, vastCompilationType);
                this.compilationType =
                    this.tagUrl["mid_roll"][this.midRollIterator]["vast_compilation_type"];
                this.tabularWaterfallIterator = this.tabularWaterfallIterator + 1;
                this.actualTypeRollLoaded = ADS_ROLL_TYPE.MID_ROLL;
                return tagVast;
            }
            else {
                if (this.groupsHasAutopromotions == true &&
                    (this.adsCustomizationTabular == true ||
                        (this.autoPromotionMidRollPlayedTimes < midRollTimesLength &&
                            this.temporizedTimes < midRollTimesLength))) {
                    this.needToPlayAutoPromotions = true;
                    this.midRollFailedTimes = 0;
                    this.autoPromotionMidRollPlayedTimes =
                        this.autoPromotionMidRollPlayedTimes + 1;
                    this.temporizedTimes = this.temporizedTimes + 1;
                    tagVast = this.autoPromotionManager.getAutoPromotionSource();
                    return tagVast;
                }
                else {
                    this.adsCustomizationMidRollTimes = null;
                }
            }
        }
        return tagVast;
    }
    /**
     * Gestisce quale tag vast utilizzare secondo quale strategia adoperare, se preroll, midroll o postroll - PER I VIDEO
     * In caso di fallimento di tutti i vast di quel roll (pre-mid-post), passo come vast la url dell'autopromozione corrente
     * @returns {String} Stringa Tag Vast per il video da usare per l'ad break
     */
    getVastForVod() {
        let tagVast = "";
        let preRollVastLength = this.tagUrl["pre_roll"].length;
        if (this.adsCustomizationPreRoll === 1 && this.needStopPreRollIter == 0) {
            if (preRollVastLength > 0 && this.preRollIterator < preRollVastLength) {
                tagVast = this.tagUrl["pre_roll"][this.preRollIterator]["tag_vast"];
                this.numberOfAds =
                    this.tagUrl["pre_roll"][this.preRollIterator]["number_of_ads"];
                this.compilationType =
                    this.tagUrl["pre_roll"][this.preRollIterator]["vast_compilation_type"];
                this.preRollIterator = this.preRollIterator + 1;
                this.actualTypeRollLoaded = ADS_ROLL_TYPE.PRE_ROLL;
                return tagVast;
            }
            else {
                if (this.groupsHasAutopromotions == true &&
                    this.autoPromotionPlayed == false) {
                    this.needToPlayAutoPromotions = true;
                    tagVast = this.autoPromotionManager.getAutoPromotionSource();
                    return tagVast;
                }
                else {
                    this.adsCustomizationPreRoll = 0;
                    this.needStopPreRollIter = 1;
                }
            }
        }
        let midRollVastLength = this.tagUrl["mid_roll"].length;
        let midRollTimesLength = this.adsCustomizationMidRollTimes == null
            ? 0
            : this.adsCustomizationMidRollTimes.length;
        if (this.currentAdType == ADS_ROLL_TYPE.PRE_ROLL) {
            this.currentAdType = 1;
            this.videoJsAds?.setSizeLoad();
        }
        if (this.adsCustomizationMidRollType > 0 && midRollTimesLength > 0) {
            if (midRollVastLength > 0 &&
                this.temporizedTimes < midRollTimesLength &&
                this.midRollFailedTimes < midRollVastLength) {
                if (this.midRollIterator >= midRollVastLength) {
                    this.midRollIterator = 0;
                }
                tagVast = this.tagUrl["mid_roll"][this.midRollIterator]["tag_vast"];
                this.numberOfAds =
                    this.tagUrl["mid_roll"][this.midRollIterator]["number_of_ads"];
                this.compilationType =
                    this.tagUrl["mid_roll"][this.midRollIterator]["vast_compilation_type"];
                this.midRollIterator =
                    this.midRollIterator + 1 >= midRollVastLength
                        ? 0
                        : this.midRollIterator + 1;
                this.actualTypeRollLoaded = ADS_ROLL_TYPE.MID_ROLL;
                return tagVast;
            }
            else {
                if (this.groupsHasAutopromotions == true &&
                    this.autoPromotionMidRollPlayedTimes < midRollTimesLength &&
                    this.temporizedTimes < midRollTimesLength) {
                    this.needToPlayAutoPromotions = true;
                    this.midRollFailedTimes = 0;
                    this.autoPromotionMidRollPlayedTimes =
                        this.autoPromotionMidRollPlayedTimes + 1;
                    this.temporizedTimes = this.temporizedTimes + 1;
                    tagVast = this.autoPromotionManager.getAutoPromotionSource();
                    return tagVast;
                }
                else {
                    this.videoJsAds?.setSizeLoad();
                    this.adsCustomizationMidRollTimes = null;
                }
            }
        }
        let postRollVastLength = this.tagUrl["post_roll"].length;
        if (this.currentAdType == ADS_ROLL_TYPE.MID_ROLL) {
            this.currentAdType = 2;
            this.videoJsAds?.setSizeLoad();
        }
        if (this.adsCustomizationPostRoll === 1 && postRollVastLength > 0) {
            if (this.needStopPostRollIter == 0) {
                tagVast = this.tagUrl["post_roll"][this.postRollIterator]["tag_vast"];
                this.numberOfAds =
                    this.tagUrl["post_roll"][this.postRollIterator]["number_of_ads"];
                this.needStopPostRollIter =
                    this.postRollIterator + 1 >= postRollVastLength
                        ? 1
                        : this.needStopPostRollIter;
                this.compilationType =
                    this.tagUrl["post_roll"][this.postRollIterator]["vast_compilation_type"];
                this.postRollIterator =
                    this.postRollIterator + 1 >= postRollVastLength
                        ? 0
                        : this.postRollIterator + 1;
                this.actualTypeRollLoaded = ADS_ROLL_TYPE.POST_ROLL;
                return tagVast;
            }
            else {
                if (this.groupsHasAutopromotions == true &&
                    this.autoPromotionPlayed == false) {
                    this.needToPlayAutoPromotions = true;
                    tagVast = this.autoPromotionManager.getAutoPromotionSource();
                    return tagVast;
                }
                else {
                    this.adsCustomizationPostRoll = 0;
                    this.needStopPostRollIter = 1;
                }
            }
        }
        return tagVast;
    }
    /**
     * Ritorna il Tag Vast corrente da usare per l'ad break
     * @returns {String} Stringa Tag Vast
     */
    getVastForADSAndVideoType() {
        this.adsCompletedLaunched = false;
        this.actualTagUrl = this.isLive
            ? this.getVastForLive()
            : this.getVastForVod();
        return this.actualTagUrl;
    }
    adsSetupManager() {
        switch (this.needToPlayAutoPromotions) {
            // Necessità di riproduzione di una autopromozione
            case true:
                this.adsCustomizationCheck();
                break;
            // Necessità di riproduzione di un adv vero
            case false:
                this.setUpImaVideoJS();
                break;
            // Necessità di riproduzione di un adv vero
            default:
                this.setUpImaVideoJS();
                break;
        }
    }
    /**
     * Setup IMA per il player VideoJS
     */
    setUpImaVideoJS() {
        // Inizializzo l'Ad Container
        this.videoPlayer.ima.initializeAdDisplayContainer();
        google.ima.settings.setVpaidMode(google.ima.ImaSdkSettings.VpaidMode.INSECURE);
        // Setto il vast
        this.videoPlayer.ima.setContentWithAdTag(null, this.actualTagUrl, false);
        // Invio la richiesta
        this.videoPlayer.ima.requestAds();
    }
    /**
     * Setup della riproduzione dell'autopromozione
     */
    setupAndPlayAutopromotion() {
        this.autoPromotionPlayed = true;
        this.autoPromotionManager.setAndPlayAutopromotionInPlayer(this.videoPlayer);
    }
    /**
     * Incrementatore midroll
     * @param {String} tagVast
     * @param {Int} vastCompilationType
     * @returns {String} newTagVast - Stringa Tag Vast
     */
    incrementMidRollLiveVastIterator(tagVast, vastCompilationType) {
        if (vastCompilationType == DEALERSHIP.FREEWHEEL_COMPILE) {
            return tagVast;
        }
        this.timestampVast = Date.now();
        this.liveMidRollIterator = this.liveMidRollIterator + 1;
        // Il correlator va rinnovato a ogni richiesta: prima veniva sostituito solo se coincideva
        // con l'ultimo timestamp compilato, cioe' quasi mai
        return tagVast
            .replace(/([?&]correlator=)[^&]*/, "$1" + this.timestampVast)
            .replace("midroll_tabellare/<n>", "midroll_tabellare/" + this.liveMidRollIterator);
    }
    /**
     * Starting Point. Inizializzatore delle pubblicità, facendo partire le pubblicità a seconda della tipologia di erogazione scelta
     */
    adsInitializer() {
        if (adsClassObject === null) {
            adsClassObject = this;
        }
        if (this.adsInitializerCheck()) {
            switch (this.playerTypeToBuild) {
                case LIB_PLAYER.PLYR: // Uso l'IMA di Google
                    console.log("inizio adsInitializer");
                    this.plyrJsAds.setUpIMA();
                    console.log("setup IMA completato");
                    if (this.isAdsPlayingStatus == false) {
                        this.videoVolume = this.videoContent.volume;
                    }
                    break;
                case LIB_PLAYER.BRID_PLAYER: // Uso le funzioni del Brid Player
                    this.videoContent = document.getElementsByClassName("brid_player")[0];
                    this.bridJsAds.setupAdsBridPlayer();
                    console.log("SetupAdsBridPlayer Completato");
                    this.adsCustomizationCheck();
                    break;
                default:
                    console.log("inizio adsInitializer");
                    this.plyrJsAds.setUpIMA();
                    console.log("setup IMA completato");
                    if (this.isAdsPlayingStatus == false) {
                        this.videoVolume = this.videoContent.volume;
                    }
                    if (this.videoEnded == false) {
                        this.videoContent.play();
                    }
                    break;
            }
        }
        else {
            if (this.playerTypeToBuild == LIB_PLAYER.BRID_PLAYER) {
                this.videoPlayer.play?.();
            }
            else {
                this.videoContent.play();
            }
        }
        if (this.isLive == true) {
            this.fillerGifManagement();
        }
    }
    /**
     * Avvia il player
     * LIB 03/09/2027 sostituito dthis.hls con le funzioni del player
     */
    startVideo() {
        if (this.isLive) {
            this.videoPlayer.src({
                src: this.source,
                type: "application/x-mpegURL",
            });
            this.videoPlayer.play();
        }
        else if (this.videoEnded == false) {
            this.videoPlayer.play();
        }
    }
    /**
     * Gestione di quale ad break gestire al momento
     */
    adsCustomizationCheck() {
        if (this.adsCustomizationPreRoll === 1 && this.needStopPreRollIter === 0) {
            this.adsCustomizationPreRoll = 0;
            this.needStopPreRollIter = 1;
            this.adsPreRoll();
        }
        else if (this.adsCustomizationTabular == true) {
            // ... può essere stata scelta la pubblicità tabellare ...
            this.adsMidrollTabular();
        }
        else if (this.adsCustomizationMidRollType > 0) {
            // ...altrimenti la pubblicità mid-roll
            this.adsMidRoll(adsClassObject);
        }
        else {
            this.videoJsAds?.visibilityLoadingSpinnerManager(false);
        }
    }
    /**
     * Avvia la pubblicità, secondo la tipologia di player attualmente in uso
     */
    playAds(adRollType) {
        console.log("playAds");
        adRollType = adRollType || 0;
        //LIB 27/08 la fillergif dava problemi - attivata per il momento solo sul midroll
        if (adRollType == ADS_ROLL_TYPE_BRID.MID_ROLL_BRID && this.isLive) {
            this.showFillerGif();
        }
        else {
            this.hideFillerGif();
        }
        if (this.isLive === false && this.videoEnded == false) {
            if (this.playerTypeToBuild == LIB_PLAYER.VIDEO_JS) {
                this.currTime = this.videoPlayer.currentTime();
            }
            else {
                this.currTime = this.videoContent.currentTime;
            }
        }
        try {
            console.log("preparazione Ads");
            if (this.needToPlayAutoPromotions == false) {
                switch (this.playerTypeToBuild) {
                    case LIB_PLAYER.PLYR: // Uso l'IMA di Google
                        console.log("playAds di Plyr");
                        this.plyrJsAds.playAdsStandard();
                        break;
                    case LIB_PLAYER.BRID_PLAYER: // Uso le funzioni del Brid Player
                        console.log("playAds di Brid");
                        this.bridJsAds.playAdsBridPlayer(adRollType);
                        break;
                    case LIB_PLAYER.VIDEO_JS:
                        // Con Video.js i break li gestisce AdsVideoJs: questo ramo legacy non va usato
                        console.warn("playAds legacy non usato con Video.js");
                        break;
                }
            }
            else {
                this.setupAndPlayAutopromotion();
            }
        }
        catch (adError) {
            //In caso di errore, viene caricato il VoD\Live, almeno viene fatto vedere qualcosa
            console.log("adError: ", adError);
            if (this.hasStartedAdsOnce) {
                this.hasStartedAdsOnce = false;
            }
        }
    }
    /**
     * Esegue un check per capire se ci sono altre pubblicità da avviare, senza fare delle init inutilmente
     * @override 09/10/2023 OLA - Faccio il check se ci sono ancora delle pubblicità da mostrare, così da evitare chiamate non necessarie
     * @returns {Boolean} adBreakExists - True: Ci sono ancora pubblicità da avviare | False: Non ci sono più pubblicità da mostrare
     */
    adsInitializerCheck() {
        // Se ci sta ancora il PreRoll
        let checkPreRoll = this.needStopPreRollIter == 0 && this.adsCustomizationPreRoll == 1;
        // Se ci sta ancora il MidRoll Temporizzato
        let checkMidRollTemporized = checkPreRoll == false && this.adsCustomizationMidRollTimes !== null
            ? this.adsCustomizationMidRollType == 1 &&
                this.adsCustomizationMidRollTimes.length > 0 &&
                typeof this.currentTimeToPlayAd !== "undefined"
            : false;
        // Se ci sta ancora il MidRoll Tabellare
        let checkMidRollTabular = checkPreRoll == false &&
            checkMidRollTemporized == false &&
            this.adsCustomizationTabular &&
            this.isAdsPlayingStatus == true;
        // Se ci sta ancora il PostRoll
        let checkPostRoll = checkPreRoll == false &&
            checkMidRollTabular == false &&
            checkMidRollTemporized == false &&
            this.adsCustomizationPostRoll > 0;
        return (checkPreRoll ||
            checkMidRollTabular ||
            checkMidRollTemporized ||
            checkPostRoll);
    }
    /**
     * Applica un resize all'ad conteiner delle pubblicità, per il fullscreen
     * @param {int} width
     * @param {int} height
     */
    resize(width, height) {
        this.adsManager.resize(width, height, google.ima.ViewMode.FULLSCREEN);
    }
    /**
     * Gestisce le pubblicità preroll
     */
    adsPreRoll() {
        if (this.playerTypeToBuild == LIB_PLAYER.BRID_PLAYER) {
            this.playAds(ADS_ROLL_TYPE_BRID.PRE_ROLL_BRID);
        }
        else if ($(this.videoContent).get(0).paused == false) {
            this.playAds(ADS_ROLL_TYPE_BRID.PRE_ROLL_BRID);
        }
        else {
            if (isIpad() || isIphone()) {
                adsClassObject.playAds(ADS_ROLL_TYPE_BRID.PRE_ROLL_BRID);
            }
            else {
                // ...altrimenti aspetto che venga messo in riproduzione
                $(this.videoContent).one("play", function () {
                    adsClassObject.playAds(ADS_ROLL_TYPE_BRID.PRE_ROLL_BRID);
                });
            }
        }
    }
    /**
     * Gestisce le pubblicità postroll
     */
    adsPostRoll() {
        this.playAds(ADS_ROLL_TYPE_BRID.POST_ROLL_BRID);
    }
    /**
     * Gestisce le pubblicità midroll
     */
    adsMidRoll() {
        switch (this.adsCustomizationMidRollType) {
            case 1:
                //Ads in MidRoll temporizzato
                this.isLive == false
                    ? this.adsTemporizerForVideo()
                    : this.adsTemporizerForLive();
                break;
            case 2:
                //Ads in MidRoll con recezione Quadratini Verdi
                if (this.isAdsPlayingStatus == 1) {
                    this.playAds(ADS_ROLL_TYPE_BRID.MID_ROLL_BRID);
                }
                break;
        }
    }
    /**
     * Gestisce l'ad break midroll temporizzato per i video
     */
    adsTemporizerForVideo() {
        if (this.playerUnmounted) {
            return;
        }
        if (this.adsCustomizationMidRollTimes !== null &&
            this.adsCustomizationMidRollTimes.length > 0) {
            if (this.playerTypeToBuild == LIB_PLAYER.VIDEO_JS) {
                if (parseInt(this.videoPlayer.currentTime()) >=
                    this.currentTimeToPlayAd &&
                    !this.adsPlaying &&
                    parseInt(this.videoPlayer.currentTime()) > 0) {
                    this.playAds(ADS_ROLL_TYPE_BRID.MID_ROLL_BRID);
                }
                else if (typeof this.currentTimeToPlayAd !== "undefined") {
                    setTimeout(() => {
                        this.adsTemporizerForVideo();
                    }, 2000);
                }
                else {
                    this.adsCustomizationMidRollType = 0;
                }
            }
            else {
                if (parseInt(this.videoContent.currentTime) >= this.currentTimeToPlayAd &&
                    !this.adsPlaying &&
                    parseInt(this.videoContent.currentTime) > 0) {
                    this.playAds(ADS_ROLL_TYPE_BRID.MID_ROLL_BRID);
                }
                else if (typeof this.currentTimeToPlayAd !== "undefined") {
                    setTimeout(() => {
                        this.adsTemporizerForVideo();
                    }, 2000);
                }
                else {
                    this.adsCustomizationMidRollType = 0;
                }
            }
        }
    }
    /**
     * Gestisce l'ad break midroll temporizzato per la live
     */
    adsTemporizerForLive() {
        let adsClassObject = this;
        let currentTimeToPlay = (typeof adsClassObject.adsCustomizationMidRollTimes[adsClassObject.temporizedTimes - 1] !== "undefined" &&
            adsClassObject.adsCustomizationMidRollTimes[adsClassObject.temporizedTimes - 1] !== null
            ? adsClassObject.currentTimeToPlayAd
            : adsClassObject.currentTimeToPlayAd) * 1000;
        if (!isNaN(currentTimeToPlay)) {
            let now = new Date();
            adsClassObject.adsMidRollLiveManager(currentTimeToPlay, now.getTime());
        }
    }
    /**
     * Avvia l'ad break se il tempo corrente coincide con il tempo in cui avviare l'ad break corrente
     * @param {int} currentTimeToPlay - Tempo in cui avviare l'ad break
     * @param {Date} now - Tempo corrente
     */
    adsMidRollLiveManager(currentTimeToPlay, now) {
        let adsClassObject = this;
        let adsLiveMidRollTimer = setTimeout(() => {
            if (adsClassObject.playerUnmounted) {
                return;
            }
            adsClassObject.playAds(ADS_ROLL_TYPE_BRID.MID_ROLL_BRID);
        }, currentTimeToPlay);
        $(adsClassObject.videoContent).one("pause", function () {
            let nownow = new Date();
            let trackTime = nownow.getTime() - now;
            let remainingTime = currentTimeToPlay - trackTime;
            clearTimeout(adsLiveMidRollTimer);
            // Controllo se il timer sia valido o abbia saltato qualche controllo e giusto fino a qui con un valore negativo
            if (remainingTime > 0) {
                $(adsClassObject.videoContent).one("play", function () {
                    let nowOnPlay = new Date();
                    adsClassObject.adsMidRollLiveManager(remainingTime, nowOnPlay.getTime());
                });
            }
        });
    }
    /**
     * Suddivide l'array dei tempi di visualizzazione degli ad
     */
    adsTimesSplitter() {
        let timesSplitted = this.adsCustomizationMidRollTimes.split(",");
        return timesSplitted.sort((a, b) => a - b);
    }
    /**
     * Gestione di salvataggio su DB dell'evento di ad start nella table 'ad_event_management', se durante il periodo del timer non c'è stata una pubblicità a buon fine
     * @returns {Boolean} true
     */
    failedAdsSaveOnDb() {
        if (this.isFirstAdFailed == false) {
            this.isFirstAdFailed = true;
            this.firstAdFailedTimer = setTimeout(() => {
                this.setAdEventOnDB(ADS_NOT_WATCHED);
            }, ADS_TIME * 1000);
        }
        this.setAdAllEventOnDB(ADS_NOT_WATCHED);
        return true;
    }
    /**
     * Salvataggio su DB dell'evento di ad start nella table 'ad_event_management'.
     * @param {number} watched - indica se il vast ha generato errore o meno (ADS_NOT_WATCHED = 0, ADS_WATCHED = 1)
     */
    setAdEventOnDB(watched) {
        this.setAdEventOnlocalStorage(watched);
        this.isFirstAdFailed = false;
    }
    generateIdentityToken(length = 16) {
        const charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        const array = new Uint8Array(length);
        crypto.getRandomValues(array);
        let token = "";
        for (let i = 0; i < length; i++) {
            token += charset[array[i] % charset.length];
        }
        return token;
    }
    /**
     * Gestisce il localStorage dell'evento di ad.
     * @param {number} watched - indica se il vast ha generato errore o meno (ADS_NOT_WATCHED = 0, ADS_WATCHED = 1)
     */
    setAdEventOnlocalStorage(watched) {
        // mi prendo l'id dell'utenet o nel caso sia nullo il quest code salvato nel local storage
        let identity = $("#navbarDropdownBurgerBabylon").attr("v") ||
            localStorage.getItem("identity_code");
        if (identity == null || identity == "") {
            identity = this.generateIdentityToken(100);
            localStorage.setItem("identity_code", identity);
        }
        let newData = {
            uid: identity.length == 100 ? Number(null) : Number(identity),
            gc: identity.length == 100 ? identity : null,
            eid: parseInt(this.relFileId),
            tvt: this.compilationType,
            t: this.currentAdType,
            vt: this.videoType,
            w: watched,
            gdprc: this.getGdprConsent(),
            oa: getRomeISOTime(),
        };
        // Recupero i dati esistenti
        let existingData = JSON.parse(localStorage.getItem("adsAnalytics"));
        if (!Array.isArray(existingData)) {
            existingData = [];
        }
        existingData.push(newData);
        // Salva i dati aggiornati nel localStorage
        localStorage.setItem("adsAnalytics", JSON.stringify(existingData));
    }
    /**
     * Avvia il Timer per il salvataggio nel localStorage dell'evento di ad.
     * @param {number} time - indica l'intervallo di tempo fra le richieste
     */
    startAnalyticsTimer(time) {
        setInterval(this.sendAnalitycs.bind(this), time);
    }
    /**
     * Funzione che invia le analytiche al server go
     */
    sendAnalitycs() {
        if (NEED_ANALYTICS == false) {
            return true;
        }
        let analytics = JSON.parse(localStorage.getItem("adsAnalytics"));
        if (analytics == null || analytics.length == 0) {
            return true;
        }
        //se ne ha meno di x aspetto
        if (analytics.length < MIN_VALUE_TO_SEND) {
            return true;
        }
        //chiata server analitiche
        //LIB 27/08 c'è un bug vengono mandate troppe richieste
        //Lorenzo ha detto di commentarlo per adesso
        // httpCallApi(ANALYTICS_GO_URL, {
        //   method: "addAnalytics",
        //   analytics: analytics,
        // }).then(
        //   (successResponse) => {
        //     if (successResponse.success == true) {
        //       // lo riprendo per sicurezza nel caso sia cambiato
        //       let analyticsSlice = JSON.parse(localStorage.getItem("adsAnalytics"));
        //       analyticsSlice = analyticsSlice.slice(analytics.length);
        //       //update local storage
        //       localStorage.setItem("adsAnalytics", JSON.stringify(analyticsSlice));
        //     }
        //   },
        //   (errorJson) => {
        //     console.log(errorJson);
        //   },
        // );
    }
    /**
     * Algoritmo firstPosition Mark 1
     * Gestione del primo vast da chiamare durante la waterfall di chiamate
     * @param {number} watched - indica se il vast ha generato errore o meno (ADS_NOT_WATCHED = 0, ADS_WATCHED = 1)
     */
    setWaterfallStartPosition(watched) {
        if (this.currentAdType == 1 &&
            this.adsCustomizationTabular == true &&
            this.tagUrl["mid_roll"].length > 0) {
            switch (watched) {
                case ADS_NOT_WATCHED:
                    if (this.tabularWaterfallIterator >= this.tagUrl["mid_roll"].length) {
                        this.midRollIterator = 0;
                        this.tabularWaterfallStartPositionIterator = 0;
                        this.tabularWaterfallIterator = 0;
                    }
                    else {
                        // Fallito l'ultimo vast del ciclo waterfall corrente
                        this.midRollIterator =
                            this.midRollIterator + 1 >= this.tagUrl["mid_roll"].length
                                ? 0
                                : this.midRollIterator + 1;
                    }
                    break;
                case ADS_WATCHED: // N-esimo vast del ciclo waterfall corrente ha avuto successo
                    // Se non sono all'ultimo vast del ciclo waterfall corrente, incremento di uno lo start position, altrimenti ricomincio da 0
                    this.tabularWaterfallStartPositionIterator =
                        this.tabularWaterfallStartPositionIterator + 1 >=
                            this.tagUrl["mid_roll"].length
                            ? 0
                            : this.tabularWaterfallStartPositionIterator + 1;
                    // Setto l'iteratore delle chiamate del ciclo waterfall a 0
                    this.midRollIterator = this.tabularWaterfallStartPositionIterator;
                    this.tabularWaterfallIterator = 0;
                    break;
                default:
                    // Fallito l'ultimo vast del ciclo waterfall corrente
                    if (this.midRollIterator + 1 >= this.tagUrl["mid_roll"].length) {
                        this.midRollIterator = 0;
                        this.tabularWaterfallStartPositionIterator = 0;
                    }
                    else // Fallito l'n-esimo vast del ciclo waterfall corrente
                     {
                        this.midRollIterator = this.midRollIterator + 1;
                    }
                    break;
            }
        }
    }
    /**
     * Algoritmo firstPosition Mark 2
     * Gestione del primo vast da chiamare durante la waterfall di chiamate
     * @var {Boolean} firstAdvErogated - Definisce se la pubblicità in prima posizione attuale ha erogato o meno
     */
    firstAdvWaterfallManager() {
        if (this.currentAdType == 1 &&
            this.adsCustomizationTabular == true &&
            this.tagUrl["mid_roll"].length > 0) {
            if (this.firstAdvErogated == false) {
                if (this.tabularWaterfallStartPositionIterator >=
                    this.tagUrl["mid_roll"].length) {
                    this.tabularWaterfallStartPositionIterator = 0;
                }
                else {
                    this.tabularWaterfallStartPositionIterator =
                        this.tabularWaterfallStartPositionIterator + 1;
                }
            }
            this.midRollIterator = this.tabularWaterfallStartPositionIterator;
            this.firstAdvErogated = true;
        }
    }
    /**
     * Salva nel DB l'evento di ad start nella table 'ad_all_event_management'. Serve per monitorare il numero di tutte le pubblicità avviate
     * @param {number} watched - indica se il vast ha generato errore o meno (ADS_NOT_WATCHED = 0, ADS_WATCHED = 1)
     */
    setAdAllEventOnDB(watched) {
        // httpCallPost(SAVE_ADS_ALL_EVENT, {
        //     tag_vast: this.actualTagUrl,
        //     files_id: this.relFileId,
        //     type: this.actualTypeRollLoaded,
        //     watched: watched,
        //     compilationType: this.compilationType,
        //     _csrf: getCsrfToken()
        // }).then(
        //     (successResponse) =>
        //     {
        //     },
        //     (errorJson) =>
        //     {
        //         generatePopUpErrorMessage(ERROR_STRING + ': ' + errorJson.message);
        //     }
        // );
    }
    /**
     * Gestione dell'ad break nel caso di Ad Tabellare
     */
    adsMidrollTabular() {
        adsClassObject = this;
        if (this.playerTypeToBuild == LIB_PLAYER.PLYR) {
            if ($(this.videoContent).get(0).paused == false) {
                this.checkIsAdsPlayingStatusTabularPolling();
            }
            else {
                // ...altrimenti aspetto che venga messo in riproduzione
                $(this.videoContent).one("play", function () {
                    adsClassObject.checkIsAdsPlayingStatusTabularPolling();
                });
            }
        }
        else {
            this.checkIsAdsPlayingStatusTabularPolling();
        }
    }
    /**
     * Gestore della richiesta dello status is_ads_playing su DB con Strategia Polling
     */
    async checkIsAdsPlayingStatusTabularPolling() {
        if (this.playerUnmounted) {
            return;
        }
        //se sono connesso alla web socket uso il polling
        if (this.isSocketConnected) {
            this.pollingAdsManagment();
            return;
        }
        //altrimenti mando le richieste al php per vedere lo status della pubblicità
        try {
            const response = CAN_CALL_ADS_PLAYING_DB
                ? await apiAds.ads.playingStatus({
                    files_id: this.relFileId,
                })
                : await apiAds.ads.goApiPlayingStatus({
                    rel: this.relFileId.toString(),
                });
            this.isAdsPlayingStatus = response.isAdsPlaying;
            this.fillerGifManagement();
        }
        finally {
            this.pollingAdsManagment();
        }
    }
    /**
     * Gestione di esecuzione ad break con strategia tabellare
     */
    pollingAdsManagment() {
        if (this.playerTypeToBuild == LIB_PLAYER.PLYR) {
            // is_ads_playing = 1 su DB
            if (this.isAdsPlayingStatus == true) {
                // Mando la Pubblicità
                this.playAds(ADS_ROLL_TYPE_BRID.MID_ROLL_BRID);
            }
            else // is_ads_playing = 0 su DB
             {
                // Se il video è in riproduzione, inizio il check durante la live...
                if ($(this.videoContent).get(0).paused == false) {
                    this.startTimerToCheckAdsStatusDuringLive();
                }
                else {
                    // ...altrimenti aspetto che venga messo in riproduzione
                    $(this.videoContent).one("play", function () {
                        adsClassObject.startTimerToCheckAdsStatusDuringLive();
                    });
                }
            }
        }
        else {
            // is_ads_playing = 1 su DB
            if (this.isAdsPlayingStatus == true) {
                // Mando la Pubblicità
                this.playAds(ADS_ROLL_TYPE_BRID.MID_ROLL_BRID);
            }
            else // is_ads_playing = 0 su DB
             {
                this.startTimerToCheckAdsStatusDuringLive();
            }
        }
    }
    /**
     * Gestore dei tempi di intervallo per il check di status di is_ads_playing
     */
    startTimerToCheckAdsStatusDuringLive() {
        let randTimerRestartBeforeCallCheck = (Math.random() * (10 - 5) + 5) * 1000;
        // Cambio il tempo di attesa tra una chiamata e l'altra in base allo stato attuale di is_ads_playing
        // Status = 1 ==> 2 secondi
        // Status = 0 ==> 4 secondi
        let timeToCheck = this.isAdsPlayingStatus == true
            ? Time_Sleep_Restart_Standard
            : randTimerRestartBeforeCallCheck;
        timeToCheck = this.isSocketConnected == false ? timeToCheck : 100;
        setTimeout(() => {
            if (this.playerUnmounted) {
                return;
            }
            this.checkIsAdsPlayingStatusTabularPolling();
        }, timeToCheck);
    }
    /**
     * Gestore ti tempo rimanente per la fine dell'ad break
     */
    adsTimerPlayer() {
        let adsClassObject = this;
        // For a linear ad, a timer can be started to poll for
        // the remaining time.
        $(this.vodLiveContainerPlyrControls)
            .children('[data-plyr="play"]')
            .addClass("plyr__control--pressed");
        this.intervalTimer = setInterval(function () {
            const remainingTime = adsClassObject.adsManager.getRemainingTime();
            adsClassObject.adsCountdownText.innerHTML =
                "- " +
                    parseInt(remainingTime / 60) +
                    " : " +
                    (parseInt(remainingTime - 60 * parseInt(remainingTime / 60)) < 10
                        ? "0"
                        : "") +
                    parseInt(remainingTime - 60 * parseInt(remainingTime / 60));
        }, 500); // every 500ms
    }
    /**
     * Creazione dell'uuid per il tag vast
     * @returns {String} Stringa uuid
     */
    uuid() {
        let userAgent = window.navigator.userAgent;
        let userAgentEncoded = encodeURI(userAgent);
        return userAgentEncoded;
    }
    /**
     * Gestione visualizzazione della gif riempitiva, dipendente dallo status del campo 'is_ads_playing'
     */
    fillerGifManagement() {
        // Con Video.js filler gif e audio durante la tabellare li gestisce AdsVideoJs
        if (this.playerTypeToBuild == LIB_PLAYER.VIDEO_JS) {
            return;
        }
        if (this.fillerGif !== null) {
            // Se è attiva la pubblicità tabellare....
            if (this.isAdsPlayingStatus == true &&
                this.fillerGif.hasClass("!hidden") == true) {
                this.showFillerGif(); // ... mantengo attiva la gif riempitiva ...
                switch (this.playerTypeToBuild) {
                    case LIB_PLAYER.PLYR:
                        $(this.videoContent).prop("muted", true);
                        $(".plyr__volume").addClass("!hidden");
                        break;
                    case LIB_PLAYER.BRID_PLAYER:
                        $(this.videoContent).prop("muted", true);
                        this.videoPlayer.muted(true);
                        break;
                    case LIB_PLAYER.VIDEO_JS:
                        this.videoJsAds?.visibilityLoadingSpinnerManager(false);
                        break;
                }
                if (this.needToFlushBuffer == false) {
                    this.needToFlushBuffer = true;
                }
            }
            // ... altrimenti se la pubblicità tabellare è disattivata e non è stata ancora ripristinata la Live ...
            else if (this.isAdsPlayingStatus == false &&
                this.fillerGif.hasClass("!hidden") == false) {
                this.hideFillerGif(); // ... altrimenti la nascondo, così da mostrare la live
                if (this.needToFlushBuffer == true) {
                    this.needToFlushBuffer = false;
                    if (this.playerTypeToBuild == LIB_PLAYER.VIDEO_JS) {
                        this.videoJsAds?.visibilityLoadingSpinnerManager(false);
                        this.videoPlayer.liveTracker.seekToLiveEdge();
                    }
                }
                // BUG 9415 : Tolto settaggio del volume per mid-roll live poiche veniva ripristinato quando ads ancora in riproduzione
                // viene risettato al completamento dell'ads
                // if (this.playerTypeToBuild !== LIB_PLAYER.VIDEO_JS) {
                //   $(".plyr__volume").removeClass("!hidden");
                // }
                // $(this.videoContent).prop("muted", false);
                // this.videoContent.play();
                // this.videoContent.volume = this.videoPlayer.muted()
                //   ? 0
                //   : this.videoVolume;
            }
            else {
                if (this.playerTypeToBuild == LIB_PLAYER.PLYR) {
                    $(".plyr__volume").removeClass("!hidden");
                }
                else if (this.playerTypeToBuild == LIB_PLAYER.VIDEO_JS &&
                    this.videoJsAds.loadingSpinner.hasClass("!hidden") == false) {
                    this.videoJsAds?.visibilityLoadingSpinnerManager(false);
                    this.videoPlayer.liveTracker.seekToLiveEdge();
                }
                else {
                    if (this.isIphone == true) {
                        this.videoPlayer.play();
                    }
                }
            }
        }
    }
    // ====================
    // -- SOCKET MANAGER --
    // ====================
    /**
     * Websocket con lo stato is_ads_playing della live (evento "adstabular").
     * Con Video.js e' solo il fallback dei CUE HLS: appena il manifest mostra un cue tag
     * AdsVideoJs la chiude con stopAdsSocket()
     */
    startSocketPolling() {
        if (this.socket) {
            return;
        }
        if (typeof io === "undefined" || !WEB_SOCKET_URL) {
            console.warn("Websocket ads non disponibile");
            return;
        }
        this.socket = io.connect(WEB_SOCKET_URL, {
            origins: "*",
            transports: ["websocket", "polling"],
            query: "rel=" + this.filesLiveID,
        });
        // client-side
        this.socket.on("connect", () => {
            console.log("+++ Connessione effettuata alla socket +++");
            this.isSocketConnected = true;
        });
        this.socket.on("adstabular", (adsPlayingStatusSocket) => {
            console.log("||| Status ads websocket: " + adsPlayingStatusSocket + " |||");
            const isAdsPlaying = adsPlayingStatusSocket === true || Number(adsPlayingStatusSocket) === 1;
            if (this.playerTypeToBuild == LIB_PLAYER.VIDEO_JS) {
                this.videoJsAds?.setLiveAdsPlaying(isAdsPlaying, "socket");
                return;
            }
            this.isAdsPlayingStatus = isAdsPlaying ? 1 : 0;
        });
        this.socket.on("disconnect", (reason) => {
            console.log("--- Disconnessione effettuata alla socket ---");
            this.isSocketConnected = false;
            if (reason === "io server disconnect") {
                // the disconnection was initiated by the server, you need to reconnect manually
                this.socket?.connect();
            }
        });
        this.socket.once("connect_failed", () => {
            this.isSocketConnected = false;
            already_call_error_websocket = true;
        });
        this.socket.once("connect_error", () => {
            this.isSocketConnected = false;
            already_call_error_websocket = true;
        });
        //si prende le informazioni del contenuto attualmente in esecuzione sulla live (usato per i fast channel con programmazione)
        this.socket.on("get_live_info", (liveInfo) => {
            if (liveInfo !== undefined) {
                this.isFastChannelAds = liveInfo.is_fast_channel == 1;
                //TODO
                //fix da modificare ora dovrebbe andarsi ad aggiornare il componente video info di react
                //updateLiveInfo(liveInfo);
            }
            else {
                console.log("dati non passati in modo corretto");
            }
        });
    }
    /**
     * Chiude il websocket: i CUE del manifest bastano, oppure il player e' stato smontato
     */
    stopAdsSocket() {
        if (this.socket) {
            this.socket.off?.();
            this.socket.disconnect?.();
            this.socket = null;
        }
        this.isSocketConnected = false;
    }
    // ======================================
    // -- WATERFALL (usato da AdsVideoJs) --
    // ======================================
    /**
     * Lista ordinata dei VAST da provare per un roll (il waterfall).
     * Per il mid-roll parto dal VAST successivo all'ultimo che ha erogato, cosi' a ogni break la
     * prima posizione ruota tra le concessionarie (come l'algoritmo firstPosition del legacy)
     * @param {number} rollType - ADS_ROLL_TYPE
     * @returns {Array} elementi { tagVast, position, waterfallIndex }
     */
    buildWaterfall(rollType) {
        let rollKey = "post_roll";
        if (rollType === ADS_ROLL_TYPE.PRE_ROLL) {
            rollKey = "pre_roll";
        }
        else if (rollType === ADS_ROLL_TYPE.MID_ROLL) {
            rollKey = "mid_roll";
        }
        const entries = (this.tagUrl[rollKey] ?? [])
            .map((tagVast, position) => ({ tagVast, position }))
            .filter((entry) => typeof entry.tagVast?.tag_vast === "string" &&
            entry.tagVast.tag_vast !== "")
            .map((entry, waterfallIndex) => ({ ...entry, waterfallIndex }));
        if (rollType !== ADS_ROLL_TYPE.MID_ROLL || entries.length === 0) {
            return entries;
        }
        const startPosition = (this.isLive
            ? this.tabularWaterfallStartPositionIterator
            : this.midRollIterator) % entries.length;
        return [
            ...entries.slice(startPosition),
            ...entries.slice(0, startPosition),
        ];
    }
    /**
     * Prepara la richiesta di un VAST del waterfall: aggiorna i dati usati dalle analytics e ritorna
     * l'url da passare a IMA
     * @param {number} rollType - ADS_ROLL_TYPE
     * @param {Object} entry - elemento ritornato da buildWaterfall
     * @returns {String} tag vast da richiedere ("" se non valido)
     */
    prepareVastRequest(rollType, entry) {
        const tagVastData = entry?.tagVast;
        if (!tagVastData || typeof tagVastData.tag_vast !== "string") {
            return "";
        }
        let tagVast = tagVastData.tag_vast;
        this.currentAdType = rollType;
        this.actualTypeRollLoaded = rollType;
        this.numberOfAds = tagVastData.number_of_ads;
        this.compilationType = tagVastData.vast_compilation_type;
        this.adsCompletedLaunched = false;
        if (this.isLive && rollType === ADS_ROLL_TYPE.MID_ROLL) {
            tagVast = this.incrementMidRollLiveVastIterator(tagVast, this.compilationType);
        }
        this.actualTagUrl = tagVast;
        return tagVast;
    }
    /**
     * Un VAST del waterfall ha erogato: il prossimo break mid-roll parte dalla posizione successiva
     */
    onWaterfallSuccess(rollType, entry) {
        if (rollType !== ADS_ROLL_TYPE.MID_ROLL || !entry) {
            return;
        }
        const nextStartPosition = entry.waterfallIndex + 1;
        if (this.isLive) {
            this.tabularWaterfallStartPositionIterator = nextStartPosition;
            this.liveMidRollIterator = 0;
        }
        else {
            this.midRollIterator = nextStartPosition;
        }
        this.midRollFailedTimes = 0;
    }
    /**
     * Giro completo del waterfall senza erogazione
     */
    onWaterfallExhausted(rollType) {
        if (rollType === ADS_ROLL_TYPE.MID_ROLL && this.isLive) {
            // come il legacy: si riparte dalla prima posizione
            this.tabularWaterfallStartPositionIterator = 0;
        }
    }
    /**
     * True mentre un'ad o un'autopromo e' in riproduzione: VideoPlayer non deve toccare la src
     */
    isBreakActive() {
        return this.videoJsAds?.isBreakActive?.() ?? false;
    }
    /**
     * @returns {Int}
     * ritorna il consenso al tracciamento
     */
    getGdprConsent() {
        let data = JSON.parse(localStorage.getItem("gbc_consent"));
        let consent = false;
        // se almeno un valore di selected è true ritorno true
        //questo perchè ci sono diversi tipi di tracciamento
        // e l'utente può rifiutarne alcuni
        if (data != undefined) {
            consent = data.some((item) => item.selected === true);
        }
        return consent === true ? 1 : 0;
    }
    /**
     * resetta il valore di asdPlaying dopo il midroll di un fastchannel
     * modificare la durata per far durare di più lo stacco pubblicitario
     */
    resetAdsStatusAfterDelay() {
        setTimeout(() => {
            if (this.playerUnmounted) {
                return;
            }
            this.isAdsPlayingStatus = false;
            this.fillerGifManagement();
            // Fine tabella e non la pubblicità non è in riproduzione
            // Altrimenti attendo la fine della pubblicità per 'lannerOn'
            if (this.isAdvStarted == false && this.isLannerOn == false) {
                // Ripristino visualizzazione Lanner
                window.dispatchEvent(new Event("lannerOn"));
                adsClassObject.isLannerOn = true;
            }
        }, 20000); // 20 secondi
    }
    /**
     * Cleanup del modulo Ads quando il player React viene smontato.
     * Il legacy viveva per tutta la durata della pagina; in React è necessario
     * fermare esplicitamente timer e socket per evitare callback su player distrutti.
     */
    destroy() {
        if (this.playerUnmounted) {
            return;
        }
        this.playerUnmounted = true;
        this.videoJsAds?.destroy?.();
        this.autoPromotionManager?.destroy?.();
        this.stopAdsSocket();
        if (this.analyticsTimer) {
            clearInterval(this.analyticsTimer);
            this.analyticsTimer = null;
        }
        if (this.intervalTimer) {
            clearInterval(this.intervalTimer);
            this.intervalTimer = null;
        }
        if (this.firstAdFailedTimer) {
            clearTimeout(this.firstAdFailedTimer);
            this.firstAdFailedTimer = null;
        }
        if (intervalID) {
            clearInterval(intervalID);
            intervalID = null;
        }
        if (window.adsForVideoPlayer === this) {
            window.adsForVideoPlayer = undefined;
        }
        if (adsClassObject === this) {
            adsClassObject = null;
        }
    }
    //LIB 04/09/2027 bugfix. quando viene mostrata/tolta la filler gif il player mette mute/unmute sennò si stente l'audio sotto
    showFillerGif() {
        if (this.fillerGif === null) {
            return;
        }
        // Salvo lo stato precedente solo quando la GIF non era già visibile
        // questo perchè non riattivo l'audio se il video è stato mutato dall'utente
        if (this.fillerGif.hasClass("!hidden")) {
            this.mutedBeforeFillerGif = this.videoPlayer?.muted?.() ?? false;
        }
        this.fillerGif.removeClass("!hidden");
        this.fillerGif.show();
        // Muto il contenuto sotto la filler GIF
        this.videoPlayer?.muted?.(true);
        if (this.videoContent) {
            this.videoContent.muted = true;
        }
    }
    hideFillerGif() {
        if (this.fillerGif === null) {
            return;
        }
        this.fillerGif.addClass("!hidden");
        this.fillerGif.hide();
        // BUG 9415 : Tolto settaggio del volume per mid-roll live poiche veniva ripristinato quando ads ancora in riproduzione
        // viene risettato al completamento dell'ads
        // Ripristino lo stato precedente
        // if (this.mutedBeforeFillerGif === false) {
        //   this.videoPlayer?.muted?.(false);
        //   if (this.videoContent) {
        //     this.videoContent.muted = false;
        //     this.videoContent.volume = this.videoVolume;
        //   }
        // }
    }
}
// OLA 14/08/2026 | Aggiunto per farlo "parlare" con PlayerJSForReact
// E' la gestione migliore?? capiamo
window.Ads = Ads;
